import { useEffect } from 'react'
import { BUCKET_URL } from '~/config/bucket'
import { Button, Flex, Icon, Typography } from '~/ds-components'
import { AwardInterface } from '~/models/interfaces'

type CompleteRouletteDialogContentPropsType = {
  dataState: { data: AwardInterface[]; isLoading: boolean }
  prizeNumber: number
}

export const CompleteRouletteDialogContent = (props: CompleteRouletteDialogContentPropsType) => {
  const { dataState, prizeNumber } = props

  useEffect(() => {
    const audio = new Audio(`${BUCKET_URL}/mecanismo-sorteio/assets/sound-effects/parabens.wav`)

    audio.play().catch((error) => {
      console.log('Autoplay bloqueado:', error)
    })

    return () => {
      audio.pause()
      audio.currentTime = 0
    }
  }, [])

  return (
    <Flex gap={16} alignItems="center" flexDirection="column">
      <Icon name="Celebration" size={48} color="green" />

      <Typography color="gray.700" variant="xLarge" sx={{ fontWeight: 600 }}>
        {`Parabéns, você ganhou ${dataState.data[prizeNumber].option}!`}
      </Typography>

      <Typography color="gray.600" textAlign="center">
        O valor do Prêmio será enviado para a sua loja e, posteriormente, repassado pela mesma para
        você.
      </Typography>

      <Typography color="gray.600" textAlign="center">
        Você poderá ver mais detalhes sobre seu Prêmio no Sistema Acerta!
      </Typography>

      <Button
        size="medium"
        as="a"
        href={`${process.env.REACT_APP_SISTEMA_ACERTA_URL}/meus-premios`}
        target="_blank"
      >
        Ir para “Meus Prêmios”
      </Button>
    </Flex>
  )
}
